import React from "react";
import { ArrowRight } from "lucide-react";
import { pricing } from "../mock";

export default function Pricing() {
  return (
    <section id="pricing" className="section-warm grain">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-20 md:py-28">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8">
          <div className="lg:col-span-7">
            <p className="eyebrow eyebrow-line">Fees & Engagement</p>
            <h2 className="font-serif-display mt-6 text-[2.1rem] md:text-[3rem] leading-[1.05] text-[#2a3325]">
              Clear pricing, <span className="italic-accent">aligned</span> to your outcome.
            </h2>
          </div>
          <div className="lg:col-span-5 flex items-end">
            <p className="text-[#4d5a45] leading-relaxed">
              Every engagement is set out in writing before work begins. We do not hold client funds, and we do not charge success commissions tied to any transaction.
            </p>
          </div>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-6">
          {pricing.map((p) => (
            <div
              key={p.title}
              className={`relative card-soft p-8 flex flex-col rounded-sm ${
                p.highlight ? "ring-1 ring-[#8a9a6b] bg-[#cfd8bd]" : ""
              }`}
            >
              {p.highlight && (
                <span className="absolute -top-3 right-6 bg-[#2a3325] text-[#e8ecdf] text-[0.65rem] tracking-[0.2em] uppercase px-3 py-1 rounded-full">
                  Most Requested
                </span>
              )}
              <p className="eyebrow">{p.tag}</p>
              <h3 className="font-serif-display text-3xl text-[#2a3325] mt-4">{p.title}</h3>
              <div className="mt-6">
                <p className="font-serif-display text-4xl text-[#2a3325]">{p.price}</p>
                <p className="text-sm text-[#6b7860] mt-1">{p.unit}</p>
              </div>
              <div className="divider my-6" />
              <ul className="space-y-3">
                {p.features.map((f) => (
                  <li key={f} className="flex gap-3 text-sm text-[#3d4838]">
                    <span className="mt-1.5 inline-block w-1.5 h-1.5 rounded-full bg-[#8a9a6b] shrink-0" />
                    {f}
                  </li>
                ))}
              </ul>
              <a href="#contact" className="btn-ghost mt-8 self-start">
                {p.cta} <ArrowRight className="w-4 h-4" />
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
